import React, { useEffect, useState } from "react"
import { Box, IconButton, Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { faCaretUp, faCaretDown } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { LocalizedEnum, LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"

type PlusMinusButtonFilterProps = {
    value: number | null
    identifier: string
    setValue: (value: number | null) => void
}

const useStyles = makeStyles()(() => ({
    container: {
        minWidth: "12rem",
        padding: ".5rem 1rem",
    },
    arrowButton: {
        width: "2rem",
        height: "2rem",
        color: "#64748B",
        "&:hover": {
            color: "#000",
        },
    },
    timeValue: {
        fontSize: "1rem",
        width: "3rem",
        textAlign: "center",
    },
    separator: {
        fontSize: "1rem",
        margin: "0 .5rem",
    },
    empty: {
        height: "2rem",
        width: "1rem",
    },
}))

export function TimeSliderFilter({ value, setValue, identifier }: PlusMinusButtonFilterProps) {
    const { classes } = useStyles()
    const [hours, setHours] = useState(0)
    const [minutes, setMinutes] = useState(0)

    useEffect(() => {
        if (value !== null) {
            setHours(Math.floor(value / 60))
            setMinutes(value % 60)
        }
    }, [value])

    const handleTimeChange = (type: "hours" | "minutes", amount: number) => {
        const newHours = type === "hours" ? Math.max(0, hours + amount) : hours
        const newMinutes = type === "minutes" ? Math.max(0, (minutes + amount) % 60) : minutes

        setHours(newHours)
        setMinutes(newMinutes)
        setValue(newHours * 60 + newMinutes)
    }

    return (
        <Box className={classes.container}>
            <LocalizedEnum base="resource-booking-chip-filter-select-title" enumValue={identifier}>
                <Typography fontWeight={600} marginBottom=".5rem">
                    Select
                </Typography>
            </LocalizedEnum>

            <Stack direction="row" justifyContent="center" alignItems="center">
                <Stack alignItems="center" spacing="0.25rem">
                    <IconButton className={classes.arrowButton} onClick={() => handleTimeChange("hours", 1)}>
                        <FontAwesomeIcon icon={faCaretUp} />
                    </IconButton>
                    <Typography className={classes.timeValue}>{hours}</Typography>
                    <IconButton className={classes.arrowButton} onClick={() => handleTimeChange("hours", -1)}>
                        <FontAwesomeIcon icon={faCaretDown} />
                    </IconButton>
                    <LocalizedStrict id="resource-booking-chip-filter-select-booking-duration-hours">
                        <Typography variant="body1">hours</Typography>
                    </LocalizedStrict>
                </Stack>

                <Stack alignItems="center" spacing="0.25rem">
                    <Box className={classes.empty} />
                    <Typography className={classes.separator}>:</Typography>
                    <Box className={classes.empty} />
                    <Box className={classes.empty} />
                </Stack>

                <Stack alignItems="center" spacing="0.25rem">
                    <IconButton className={classes.arrowButton} onClick={() => handleTimeChange("minutes", 10)}>
                        <FontAwesomeIcon icon={faCaretUp} />
                    </IconButton>
                    <Typography className={classes.timeValue}>{minutes}</Typography>
                    <IconButton className={classes.arrowButton} onClick={() => handleTimeChange("minutes", -10)}>
                        <FontAwesomeIcon icon={faCaretDown} />
                    </IconButton>
                    <LocalizedStrict id="resource-booking-chip-filter-select-booking-duration-minutes">
                        <Typography variant="body1">minutes</Typography>
                    </LocalizedStrict>
                </Stack>
            </Stack>
        </Box>
    )
}
